import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { STACK_UNLOCK } from "./gql";

const useUnlockStack = createDefaultMutationHook(STACK_UNLOCK);
export const useBulkUnlockStack = createBulkMutationHook(STACK_UNLOCK);

export default useUnlockStack;
